import { IRest } from './rest.interface';

export class SlaRule implements IRest {
  className = 'Regra de SLA';

  id: string;
  workspaceId: string;
  contractId?: string | null;

  serviceType: string;
  priority: string;

  responseTimeValue: number;
  responseTimeUnit: string;

  resolutionTimeValue: number;
  resolutionTimeUnit: string;

  softDelete?: boolean;
  createdAt?: string;
  updatedAt?: string;

  constructor(data?: any) {
    if (data) this.Deserialize(data);
  }

  Serialize() {
    return {
      id: this.id,
      workspaceId: this.workspaceId,
      contractId: this.contractId ?? null,

      serviceType: this.serviceType,
      priority: this.priority,

      responseTimeValue: this.responseTimeValue,
      responseTimeUnit: this.responseTimeUnit,

      resolutionTimeValue: this.resolutionTimeValue,
      resolutionTimeUnit: this.resolutionTimeUnit,

      softDelete: this.softDelete ?? false,
    };
  }

  Deserialize(data: any) {
    this.id = data?.id ?? undefined;
    this.workspaceId = data?.workspaceId ?? undefined;
    this.contractId = data?.contractId ?? null;

    this.serviceType = data?.serviceType ?? '';
    this.priority = data?.priority ?? '';

    this.responseTimeValue = data?.responseTimeValue ?? 1;
    this.responseTimeUnit = data?.responseTimeUnit ?? '';

    this.resolutionTimeValue = data?.resolutionTimeValue ?? 1;
    this.resolutionTimeUnit = data?.resolutionTimeUnit ?? '';

    this.softDelete = data?.softDelete ?? false;

    this.createdAt = data?.createdAt ?? undefined;
    this.updatedAt = data?.updatedAt ?? undefined;

    return this;
  }
}
